import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/AlfaPack_Logo_Vectores_alfapack_solutions_horizontal.png'


const _hoisted_1 = {
  class: "navbar is-transparent is-mobile pt-6",
  role: "navigation",
  "aria-label": "main navigation",
  style: {"border-bottom":"1px solid gray"}
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "AlfaPack_Logo_Vectores_alfapack_solutions_horizontal",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  id: "alfaNavMobile",
  class: "navbar-menu"
}
const _hoisted_9 = { class: "navbar-start" }
const _hoisted_10 = { class: "navbar-item has-dropdown is-hoverable" }
const _hoisted_11 = {
  key: 0,
  class: "navbar-dropdown"
}
const _hoisted_12 = {
  key: 1,
  id: "alfaNav",
  class: "navbar-menu"
}
const _hoisted_13 = { class: "navbar-start" }
const _hoisted_14 = {
  key: 0,
  class: "navbar is-transparent level is-mobile",
  style: {"width":"100%"}
}
const _hoisted_15 = { class: "image heading" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  key: 1,
  class: "navbar is-transparent level is-mobile",
  style: {"width":"100%"}
}
const _hoisted_18 = { class: "navbar-start" }
const _hoisted_19 = { class: "image heading" }
const _hoisted_20 = ["src", "alt"]

import { CLASIFICACION_EQUIPOS } from "@/use-equipos";
import { Ref, ref } from "vue";
import { useWindowSize } from "vue-window-size";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const { width } = useWindowSize();

const showEquiposNav: Ref<boolean> = ref(false);

function toggleEquiposNav() {
  showEquiposNav.value = !showEquiposNav.value;
}

function showMenu() {
  const mobileNav = document.getElementById("alfaNavMobile");
  let isDisplayed = mobileNav?.style.display;
  if (mobileNav && isDisplayed && isDisplayed == "block") {
    mobileNav.setAttribute("style", "display: none !important;");
  } else if (mobileNav && (!isDisplayed || isDisplayed == "none")) {
    mobileNav.setAttribute("style", "display: block !important;");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "navbar-item is-hoverable"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          onClick: showMenu,
          role: "button",
          class: "navbar-burger",
          "aria-label": "menu",
          "aria-expanded": "false",
          "data-target": "alfaNav",
          style: {"margin-top":"auto","margin-bottom":"auto"}
        }, _hoisted_7)
      ]),
      (_unref(width) < 768)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/nosotros",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("NOSOTROS")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", {
                  class: "navbar-link is-arrowless nav-text",
                  onClick: toggleEquiposNav
                }, " EQUIPOS "),
                (showEquiposNav.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CLASIFICACION_EQUIPOS), (clasificacion, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "navbar-item level-item is-uppercase nav-equipo-text"
                        }, [
                          _createVNode(_component_router_link, { to: "/equipo" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(clasificacion.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_router_link, {
                to: "/representadas",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("REPRESENTADAS")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("NOTICIAS")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/cotizaciones",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("COTIZACIONES")
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/nosotros",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("NOSOTROS")
                ]),
                _: 1
              }),
              _createElementVNode("div", { class: "navbar-item has-dropdown is-hoverable" }, [
                _createElementVNode("a", {
                  class: "navbar-link is-arrowless nav-text",
                  onClick: toggleEquiposNav
                }, " EQUIPOS ")
              ]),
              _createVNode(_component_router_link, {
                to: "/representadas",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("REPRESENTADAS")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("NOTICIAS")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/cotizaciones",
                class: "navbar-item nav-text is-hoverable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("COTIZACIONES")
                ]),
                _: 1
              })
            ])
          ]))
    ]),
    (showEquiposNav.value && _unref(width) >= 768)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_14, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "navbar-item level-item has-text-centered is-uppercase nav-equipo-text"
            }, [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, { to: "/equipo" }, {
                  default: _withCtx(() => [
                    _createElementVNode("figure", _hoisted_15, [
                      _createElementVNode("img", {
                        src: _unref(CLASIFICACION_EQUIPOS)[n - 1].logo,
                        alt: _unref(CLASIFICACION_EQUIPOS)[n - 1].alt,
                        style: {"max-height":"35px","width":"auto"}
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_unref(CLASIFICACION_EQUIPOS)[n - 1].label), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (showEquiposNav.value && _unref(width) >= 768)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "navbar-item level-item has-text-centered is-uppercase nav-equipo-text"
              }, [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, { to: "/equipo" }, {
                    default: _withCtx(() => [
                      _createElementVNode("figure", _hoisted_19, [
                        _createElementVNode("img", {
                          src: _unref(CLASIFICACION_EQUIPOS)[n + 5].logo,
                          alt: _unref(CLASIFICACION_EQUIPOS)[n + 5].alt,
                          style: {"max-height":"35px","width":"auto"}
                        }, null, 8, _hoisted_20)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_unref(CLASIFICACION_EQUIPOS)[n + 5].label), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})